/**
 * #190: no meter mqtt / mqtt-action-runner en el entry de tr-app.
 * El módulo real se carga al primer init / subscribe / shutdown.
 */
let _modPromise;

function loadMqttNotifications() {
  if (!_modPromise) {
    _modPromise = import('./mqtt-notifications.js');
  }
  return _modPromise;
}

export async function initMqttNotifications(...args) {
  const m = await loadMqttNotifications();
  return m.initMqttNotifications(...args);
}

export async function shutdownMqttNotifications(...args) {
  const m = await loadMqttNotifications();
  return m.shutdownMqttNotifications(...args);
}

export async function subscribeUserChannel(...args) {
  const m = await loadMqttNotifications();
  return m.subscribeUserChannel(...args);
}

export async function subscribeToChannels(...args) {
  const m = await loadMqttNotifications();
  return m.subscribeToChannels(...args);
}

export async function collectWorkstationMqttActionTopics(...args) {
  const m = await loadMqttNotifications();
  return m.collectWorkstationMqttActionTopics(...args);
}
